
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Badge } from "@/components/ui/badge";
import { WIDGET_REGISTRY, CATEGORY_LABELS, type WidgetCategory } from "@/lib/widget-registry";
import { Plus, Check } from "lucide-react";
import { useState } from "react";

interface WidgetPickerProps {
  activeWidgetIds: string[];
  onAdd: (id: string) => void;
  onRemove: (id: string) => void;
}

export function WidgetPicker({ activeWidgetIds, onAdd, onRemove }: WidgetPickerProps) {
  const [open, setOpen] = useState(false);
  const categories = ["kpi", "chart", "top"] as WidgetCategory[];

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger className="inline-flex items-center gap-2 rounded-md text-sm font-medium bg-primary text-primary-foreground hover:bg-primary/90 h-9 px-4 cursor-pointer">
        <Plus className="h-4 w-4" />
        Přidat widget
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Přidat widget na dashboard</DialogTitle>
        </DialogHeader>
        <div className="space-y-5 max-h-[60vh] overflow-y-auto">
          {categories.map((cat) => (
            <div key={cat}>
              <p className="text-sm font-semibold text-[var(--primary)] mb-2">{CATEGORY_LABELS[cat]}</p>
              <div className="space-y-1.5">
                {WIDGET_REGISTRY.filter((w) => w.category === cat).map((widget) => {
                  const isActive = activeWidgetIds.includes(widget.id);
                  return (
                    <button
                      key={widget.id}
                      onClick={() => {
                        if (isActive) onRemove(widget.id);
                        else onAdd(widget.id);
                      }}
                      className="w-full flex items-center gap-3 p-2.5 rounded-lg hover:bg-accent transition-colors text-left cursor-pointer"
                    >
                      <div className={`h-5 w-5 rounded border flex items-center justify-center flex-shrink-0 ${isActive ? "bg-primary border-primary" : "border-border"}`}>
                        {isActive && <Check className="h-3 w-3 text-primary-foreground" />}
                      </div>
                      <span className="text-sm flex-1">{widget.name}</span>
                      <Badge variant="outline" className="text-[10px]">
                        {widget.defaultW}x{widget.defaultH}
                      </Badge>
                    </button>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
